module.exports = __webpack_public_path__ + "img/img5.cf0a93fa.svg";